import { zoneDetailsActionType } from '../types/zoneDetailsTypes';
import { SET_ZONE_TYPE, SET_CURRENT_TAB, SET_ZONE_MODAL, SET_DISTRICT_BY_ZONE, SET_DISTRICT_BY_STATE, SET_ZONE_BY_ZONE_ID, SET_HEALTH_BLOCK_BY_ID, SET_VILLAGE_BY_BLOCK_ID, SET_WARD_BY_ULB_ID, SET_ZONE } from '@store/constant';
export interface ZoneDetailsState {
  type: string;
  currentTab: string;
  zoneModal: any,
  districtByZone: any,
  zoneByZoneId: any,
  healthBlockById: any,
  districtByState: any,
  villageByBlockId: any,
  wardByULBId: any,
  zoneId: string
}

export const initialState: ZoneDetailsState = {
  type: 'Zone',
  currentTab: '',
  zoneModal: '',
  districtByZone: [],
  zoneByZoneId: [],
  healthBlockById: [],
  districtByState: [],
  villageByBlockId: [],
  wardByULBId: [],
  zoneId: ''
};

const zoneDetailsReducer = (
  state = initialState,
  action: zoneDetailsActionType,
): ZoneDetailsState => {
  switch (action.type) {
    case SET_ZONE_TYPE:
      return { ...state, type: action.payload };
    case SET_CURRENT_TAB:
      return { ...state, currentTab: action.payload };
    case SET_ZONE_MODAL:
      return { ...state, zoneModal: action.payload };
    case SET_DISTRICT_BY_ZONE:
      return { ...state, districtByZone: { ...state.districtByZone, [action.payload.key]: action.payload.value } };
    case SET_DISTRICT_BY_STATE:
      return { ...state, districtByState: { ...state.districtByState, [action.payload.key]: action.payload.value } };
    case SET_ZONE_BY_ZONE_ID:
      return { ...state, zoneByZoneId: { ...state.zoneByZoneId, [action.payload.key]: action.payload.value } };
    case SET_HEALTH_BLOCK_BY_ID:
      return { ...state, healthBlockById: { ...state.healthBlockById, [action.payload.key]: action.payload.value } };
    case SET_VILLAGE_BY_BLOCK_ID:
      return { ...state, villageByBlockId: { ...state.villageByBlockId, [action.payload.key]: action.payload.value } };
    case SET_WARD_BY_ULB_ID:
      return { ...state, wardByULBId: { ...state.wardByULBId, [action.payload.key]: action.payload.value } };
    case SET_ZONE:
      return { ...state, zoneId: action.payload };
    default:
      return state;
  }
};

export default zoneDetailsReducer;
